import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import StarFill from '@deliveroo/icon-set/react/StarFill';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Span from '@deliveroo/consumer-component-library/components/Span';

import styles from './styles.scss';

/**
 * Component to display a star rating and description
 */
export default function StarRating({
  rating,
  band,
  description,
  count,
  isMonochrome,
  isPlaceholder,
  placeholderClass,
}) {
  const containerClasses = classnames(styles.container, {
    [placeholderClass]: isPlaceholder,
    [styles.placeholder]: isPlaceholder,
  });

  const bandClassName = isMonochrome ? undefined : classnames(styles.band, styles[band]);

  const text = `${rating}\u00A0${description}`;

  return (
    <div className={containerClasses}>
      <Span size="small" color={isMonochrome ? 'white' : undefined}>
        <span className={bandClassName}>
          <Icon component={StarFill} size={18} />
          {'\u00A0'}
          {text}
        </span>
        {count && (
          <Fragment>
            {' '}
            <Span size="small" color={isMonochrome ? 'white' : 'grey'}>
              ({count})
            </Span>
          </Fragment>
        )}
      </Span>
    </div>
  );
}

StarRating.propTypes = {
  /**
   * Displayed rating value
   */
  rating: PropTypes.string.isRequired,

  /**
   * Number of ratings
   */
  count: PropTypes.string,

  /**
   * Description for the rating, e.g. Excellent, Very Good etc.
   */
  description: PropTypes.string,

  /**
   * Ratings band for the rating
   */
  band: PropTypes.oneOf(['excellent', 'very-good', 'good', 'fair']),

  /**
   * Should the star rating be rendered in monochrome (i.e. white text)
   */
  isMonochrome: PropTypes.bool,

  /**
   * Should the component be rendered as a placeholder for real content?
   */
  isPlaceholder: PropTypes.bool,

  placeholderClass: PropTypes.string,
};

StarRating.defaultProps = {
  count: undefined,
  description: '',
  band: undefined,
  isMonochrome: false,
  isPlaceholder: false,
  placeholderClass: '',
};
